import { Box, BoxProps } from '@material-ui/core';

// ----------------------------------------------------------------------

export default function Logo(props: BoxProps) {
  return (
    <Box
      component="img"
      alt="logo"
      src="/static/brand/BrightlQ-logo-koyu.svg"
      height={100} /* height={40} */
      {...props}
    />
  );
}
